import { Link } from '@shared/components/atoms/Link'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const UnorderedList = styled.ul`
  list-style-type: none;
  margin-bottom: 40px;

  > li {
    padding: 8px 0px;
  }

  @media only screen and (min-width: 992px) {
    margin-bottom: 0px;
  }
`

const ListTitle = styled.h2`
  display: block;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;

  @media only screen and (min-width: 992px) {
    margin-bottom: 21px;
  }
`

const Logo = styled.img`
  margin: 0 6px -5px 0;
`

const Info = styled.small`
  display: block;
  max-width: 200px;
  color: #4e5464;
  opacity: 0.6;
  margin-left: 26px;
  font-size: 12px;
  line-height: 12px;
`

const NavigationList = ( { title, navigationList } ) => {
  const navigationListLink = ( navigationItem, linkContent ) => {
    return (
      <Link
        path={ navigationItem.url }
        target={ navigationItem.url.includes( 'api.whatsapp.com' ) ? '_blank' : '_self' }
        text={ linkContent }
        typography={{
          'color': 'cinza500',
          'fontSizeDesktop': 'xs',
          'fontSizeMobile': 'xs',
          'fontWeight': 's',
          'fontFamily': 'notoSans',
          'variant': 'customText',
        }}
      />
    )
  }

  return (
    <UnorderedList>
      <ListTitle>{ title }</ListTitle>
      {
        navigationList && navigationList.map( ( navigationItem ) => {
          const linkContent = (
            <>
              { navigationItem.logo && <Logo src={ navigationItem.logo } /> }
              { navigationItem.name }
            </>
          )

          return (
            <li key={ navigationItem.id }>
              {
                navigationItem.useHeading
                  ?
                  <h3>{ navigationListLink( navigationItem, linkContent ) }</h3>
                  :
                  ( navigationListLink( navigationItem, linkContent ) )
              }
              { navigationItem.infoText && <Info>{ navigationItem.infoText }</Info> }
            </li>
          )
        } )
      }
    </UnorderedList>
  )
}

NavigationList.propTypes = {
  'navigationList': PropTypes.array.isRequired,
  'title': PropTypes.string.isRequired
}

export default NavigationList
